import { z } from 'zod'

/**
 * Query params for list endpoints. `z.coerce` is deliberate — query strings
 * always arrive as strings, and REST callers shouldn't have to pre-parse.
 */
export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(50),
})
export type PaginationQuery = z.infer<typeof paginationQuerySchema>

export function paginatedSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    data: z.array(item),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
  })
}

export const apiErrorSchema = z.object({
  error: z.string(),
})
export type ApiError = z.infer<typeof apiErrorSchema>

/** Kept for the benefit of client-side code that types `fetch` responses. */
export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  pageSize: number
}
